import { Grid, Typography } from "@material-ui/core";
import sign from "../../../assets/img/james_sign.png";

const Details = () => {
  return (
    <Grid container style={{ marginTop: "5px" }}>
      <Grid item>
        <Typography style={{ fontSize: "12px" }}>
          Radon levels in a home can be influenced by many factors including
          weather, season, living conditions, and occupancy patterns. Temporary
          conditions observed during the testing period may cause the test to
          not reflect the client’s risk from radon. The levels stated for this
          time period had the following situations present.
        </Typography>
      </Grid>
      <Grid item container>
        <Grid item style={{ marginTop: "21px" }}>
          <Typography style={{ fontSize: "12px" }}>
            Report Reviewed and Certified by
          </Typography>
          <Typography style={{ fontSize: "12px" }}>
            NRPP Lab ID 113936-AL
          </Typography>
        </Grid>
        <Grid item style={{ marginTop: "21px" }}>
          <img
            alt="james-sign"
            src={sign}
            style={{
              width: "100%",
              backgroundColor: "transparent",
              paddingBottom: "10px",
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
export default Details;
